import React from 'react'
import ContextNavModels from './ContextNav'
import ContextLoadingModels from './ContextLoading'
import ContextRollCallModels from './ContextRollCall'
import ContextDashboardModels from './ContextDashboard'
import ContextDelayModels from './ContextDelay'
import ContextOverTimeModels from './ContextOverTime'
import ContextAbsenceModels from './ContextAbsence'
import ContextVacationModels from './ContextVacation'

export default function ContextContainer(props: any) {

    return (
        <>
            <ContextDashboardModels>
                <ContextAbsenceModels>
                    <ContextVacationModels>
                        <ContextOverTimeModels>
                            <ContextDelayModels>
                                <ContextRollCallModels>
                                    <ContextLoadingModels>
                                        <ContextNavModels>
                                            {props.children}
                                        </ContextNavModels>
                                    </ContextLoadingModels>
                                </ContextRollCallModels>
                            </ContextDelayModels>
                        </ContextOverTimeModels>
                    </ContextVacationModels>
                </ContextAbsenceModels>
            </ContextDashboardModels>
        </>
    )
}